import React, { Component } from 'react';

import { Link } from 'library';

export default class AdminCard extends Component {
    render() {
        let data = this.props.data;
        let name = data['name'];
        let icon = data['icon'] + '.png';

        return (
            <Link className="simple-card admin-card" href={`/${data['url']}/`}>
                <table>
                    <tbody>
                        <tr>
                            <td
                                style={{
                                    verticalAlign: 'top',
                                    paddingRight: '20px',
                                }}
                            >
                                <img
                                    className="admin-icon"
                                    src={`/static/icons/${icon}`}
                                />
                            </td>
                            <td
                                style={{
                                    verticalAlign: 'top',
                                    paddingTop: '5px',
                                }}
                            >
                                <h3>{name}</h3>

                                <p
                                    style={{
                                        fontStyle: 'italic',
                                        fontSize: '18px',
                                        fontWeight: 'lighter',
                                        letterSpacing: '0.01em',
                                    }}
                                >
                                    {data['helper_text']}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Link>
        );
    }
}
